import { onError } from '@apollo/client/link/error';
import { ServerParseError } from '@apollo/client';
import {
  AppLogger,
  LogTypes,
  DatadogClient,
  DynatraceClient,
  AuthClient,
} from '@workivate/tho-web-shared';

import { sessionInvalidationHTTPStatus } from 'wa-storybook/components/modal/session-invalidation-alert-modal/constants';

const errorLink = () =>
  onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.map(error => {
        const message = `[GraphQL error]: Message: ${error.message}, Location: ${error.locations}, Path: ${error.path}`;

        DatadogClient.addError(error);
        DatadogClient.logMessage(message);

        DynatraceClient.sendException(error);
        DynatraceClient.sendEvent(message);
      });
    }
    if (networkError) {
      const message = `[GraphQL error][Network error]: ${JSON.stringify(networkError)}`;

      DatadogClient.addError(networkError);
      DatadogClient.logMessage(message);

      DynatraceClient.sendException(networkError);
      DynatraceClient.sendEvent(message);

      if (
        (networkError as ServerParseError).statusCode ===
        sessionInvalidationHTTPStatus
      ) {
        AppLogger.logWithOptions({
          message: 'Attempting token refresh after 401 GraphQL error',
          level: LogTypes.Log,
          shouldLogToDatadog: true,
          shouldLogToDynatrace: true,
        });

        // We refresh the tokens to see if this is session expiry
        // if refresh fails, AuthEvents.subscribe in run-with-usl.tsx will handle logout
        AuthClient.refreshTokens().catch(() => {
          // This prevents unhandled promise rejection
        });
      }
    }
  });

export default errorLink;
